import React from "react";

const SidebarNavigationItem = ({ svg, title }) => {
  return (
    <>
      <div className="h-10 cursor-pointer font-medium hover:text-gray-900 text-gray-700 hover:bg-gray-200 rounded-md flex space-x-3 p-2 items-center">
        <div className="h-6 w-6">{svg}</div>
        <h2> {title}</h2>
      </div>
    </>
  );
};

export default SidebarNavigationItem;
